import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Row } from "reactstrap";

const Breadcrumbs = (props) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (props.path) {
      navigate(props.path);
      return;
    }
    navigate(-1);
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              {props.navigation ? (
                <button
                  type="button"
                  className="btn btn-link p-0 text-decoration-none"
                  onClick={handleBack}
                  aria-label="Go back"
                >
                  <i className="ri-arrow-left-line fs-3" />
                </button>
              ) : null}
              <h4 className="mb-0 font-size-18">{props.breadcrumbItem}</h4>
            </div>
            <div className="page-title-right">
              <Breadcrumb listClassName="m-0">
                <BreadcrumbItem>
                  <Link to="#">{props.title}</Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                  {/* <Link to="#"> */}
                  {props.breadcrumbItem}
                  {/* </Link> */}
                </BreadcrumbItem>
              </Breadcrumb>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}



export default Breadcrumbs;
